goog.provide("shadow.js.shim.module$pdfjs_dist$web$pdf_viewer");
goog.provide("module$shadow_js_shim_module$pdfjs_dist$web$pdf_viewer");
shadow.js.shim.module$pdfjs_dist$web$pdf_viewer = shadow.js.nativeProvides["pdfjs-dist/web/pdf_viewer"] = shadow$bridge("pdfjs-dist/web/pdf_viewer");
module$shadow_js_shim_module$pdfjs_dist$web$pdf_viewer.default = shadow.js.shim.module$pdfjs_dist$web$pdf_viewer;
